/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require('grpc-web');

var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
const proto = {};
proto.reportpb = require('./position_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.PositionServiceClient = function (hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;
};

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.PositionServicePromiseClient = function (hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListPositionRequest,
 *   !proto.reportpb.ListPositionResponse>}
 */
const methodDescriptor_PositionService_ListPosition = new grpc.web.MethodDescriptor(
  '/reportpb.PositionService/ListPosition',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListPositionRequest,
  proto.reportpb.ListPositionResponse,
  /**
   * @param {!proto.reportpb.ListPositionRequest} request
   * @return {!Uint8Array}
   */
  function (request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListPositionResponse.deserializeBinary
);

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.ListPositionRequest,
 *   !proto.reportpb.ListPositionResponse>}
 */
const methodInfo_PositionService_ListPosition =
  new grpc.web.AbstractClientBase.MethodInfo(
    proto.reportpb.ListPositionResponse,
    /**
     * @param {!proto.reportpb.ListPositionRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.reportpb.ListPositionResponse.deserializeBinary
  );

/**
 * @param {!proto.reportpb.ListPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.ListPositionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListPositionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.PositionServiceClient.prototype.listPosition = function (
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/reportpb.PositionService/ListPosition',
    request,
    metadata || {},
    methodDescriptor_PositionService_ListPosition,
    callback
  );
};

/**
 * @param {!proto.reportpb.ListPositionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListPositionResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.PositionServicePromiseClient.prototype.listPosition = function (
  request,
  metadata
) {
  return this.client_.unaryCall(
    this.hostname_ + '/reportpb.PositionService/ListPosition',
    request,
    metadata || {},
    methodDescriptor_PositionService_ListPosition
  );
};

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.GetPositionAccountAllocationRequest,
 *   !proto.reportpb.GetPositionAccountAllocationResponse>}
 */
const methodDescriptor_PositionService_GetPositionAccountAllocation =
  new grpc.web.MethodDescriptor(
    '/reportpb.PositionService/GetPositionAccountAllocation',
    grpc.web.MethodType.UNARY,
    proto.reportpb.GetPositionAccountAllocationRequest,
    proto.reportpb.GetPositionAccountAllocationResponse,
    /**
     * @param {!proto.reportpb.GetPositionAccountAllocationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.reportpb.GetPositionAccountAllocationResponse.deserializeBinary
  );

/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.reportpb.GetPositionAccountAllocationRequest,
 *   !proto.reportpb.GetPositionAccountAllocationResponse>}
 */
const methodInfo_PositionService_GetPositionAccountAllocation =
  new grpc.web.AbstractClientBase.MethodInfo(
    proto.reportpb.GetPositionAccountAllocationResponse,
    /**
     * @param {!proto.reportpb.GetPositionAccountAllocationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.serializeBinary();
    },
    proto.reportpb.GetPositionAccountAllocationResponse.deserializeBinary
  );

/**
 * @param {!proto.reportpb.GetPositionAccountAllocationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.reportpb.GetPositionAccountAllocationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.GetPositionAccountAllocationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.PositionServiceClient.prototype.getPositionAccountAllocation = function (
  request,
  metadata,
  callback
) {
  return this.client_.rpcCall(
    this.hostname_ + '/reportpb.PositionService/GetPositionAccountAllocation',
    request,
    metadata || {},
    methodDescriptor_PositionService_GetPositionAccountAllocation,
    callback
  );
};

/**
 * @param {!proto.reportpb.GetPositionAccountAllocationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.GetPositionAccountAllocationResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.PositionServicePromiseClient.prototype.getPositionAccountAllocation =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ + '/reportpb.PositionService/GetPositionAccountAllocation',
      request,
      metadata || {},
      methodDescriptor_PositionService_GetPositionAccountAllocation
    );
  };

module.exports = proto.reportpb;
